/*
 * Created by alex@hackerbay.com on 21.12.2018
 * Copyright Singularity Technologies GmbH (c) 2018. All rights reserved
 */

import * as React from "react";
import {translate, Trans} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Col, Container, Row} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import Subtitle from "../../components/Subtitle";
import StatusBox from "../../components/StatusBox";
import InfoBox from "../../components/InfoBox";
import iconTechnician from "../../media/icons/technician.svg"
import StatusBar from "../../components/StatusBar";
import BottomBarPassive from "../../components/BottomBarPassive";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import moment from "moment";
import {
    MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT,
    MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_DESKTOP, MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_ONLY_WEEKDAY
} from "../../common";
import SideBarTechnicianInfo from "../../components/SideBarTechnicianInfo";
import SingleButton from "../../components/SingleButton";
import {StatusBarDesktop} from "../../components/StatusBarDesktop";
import timeSlotFormatter from "../../timeSlotFormatter";
import technicianAppointmentRequired from "../../technicianRequired";
import TextField from '@material-ui/core/TextField';
import vodafoneLogo from "../../media/icons/vf-logo.png";


class Stage6ConfirmAppointment extends React.Component {
    constructor(props){

        super(props);

        // console.log( "Stage6ConfirmAppointment / benachrichtigungPer: " + props.benachrichtigungPer );
        // console.log( "props" );
        // console.log( props );

    }


    confirmAppointment = () => {
        this.props.confirmAppointment();
    };

    render() {
        const timeSlot = this.props.ds360APIResult.appointmentTimeSlot;
        const timeSlotText = timeSlotFormatter(timeSlot).text;
        const dateText = moment(this.props.ds360APIResult.proposalDate)
            .format(MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_DESKTOP);

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;


        // console.log( "Stage6ConfirmAppointment /render / benachrichtigungPer: " + this.props.benachrichtigungPer );
        // console.log( this.props );

        return <Container>

            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                    {footerLnk}
                </Row>
                <StatusBar
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={technicianAppointmentRequired(this.props.ds360APIResult)}
                />
                <SpacerRow/>
                <Header
                    textResource={"appointment_available"}
                />
                <SpacerRow/>
                <TextBody
                    textResource={"please_make_sure"}
                />
                <SpacerRow/>
                <ul>
                    <li>{i18n.t("name_on_door")}</li>
                    <li>{i18n.t("access_to_basement")}</li>
                    <li>{i18n.t("phone_ready")}</li>
                </ul>

                <span className={"fixed-to-bottom"}>
                    <InfoBox
                        cardType={"warning"}
                        textResource={"first_appointment_free"}
                        buttonTextResource={"change_appointment"}
                        buttonOnClick={this.props.changeAppointment}
                    />
                    <BottomBarPassive
                        weekday={moment(this.props.ds360APIResult.proposalDate)
                            .format(MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_ONLY_WEEKDAY)}
                        dateText={dateText}
                        timeText={"time_o_clock"}
                        time={timeSlotText}
                        buttonTextResource={"confirm"}
                        buttonOnClick={this.confirmAppointment}
                    />
                    <TextField
                        id={"benachrichtigungPer"}
                        type={"hidden"}
                        value={this.props.benachrichtigungPer}
                    />
                </span>
            </MobileView>

            <BrowserView>
                <Row>
                {footerLnk}
                </Row>
                <StatusBarDesktop
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={technicianAppointmentRequired(this.props.ds360APIResult)}
                />
                <Row>
                    <Col xs={7}  lg={{ size: 5, offset: 1 }} style={{marginTop:"12px"}}>
                        <Header
                            textResource={"appointment_available"}
                        />
                        <SpacerRow/>
                        <TextBody
                            textResource={"please_make_sure"}
                        />
                        <SpacerRow/>
                        <ul>
                            <li>{i18n.t("name_on_door")}</li>
                            <li>{i18n.t("access_to_basement")}</li>
                            <li>{i18n.t("phone_ready")}</li>
                        </ul>

                    </Col>
                    <Col xs={5}  lg={{ size: 4, offset: 1 }} className={"round-corners shadow bg-white"}>
                        <SideBarTechnicianInfo
                            dateText={dateText}
                            timeText={"time_o_clock"}
                            time={timeSlotText}
                        />
                        <SpacerRow/>
                        <InfoBox
                            cardType={"warning"}
                            textResource={"first_appointment_free"}
                            buttonTextResource={"change_appointment"}
                            buttonOnClick={this.props.changeAppointment}
                        />
                        <SpacerRow/>
                        <SingleButton
                            buttonTextResource={"confirm"}
                            buttonOnClick={this.confirmAppointment}
                        />
                        <TextField
                            id={"benachrichtigungPer"}
                            type={"hidden"}
                            value={this.props.benachrichtigungPer}
                        />
                        <SpacerRow/>

                    </Col>
                </Row>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage6ConfirmAppointment);
